/* eslint-disable jsx-a11y/anchor-is-valid */
import { Box, Button, Grid, makeStyles, TextField } from '@material-ui/core'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import React, { useEffect, useState } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { Link, Route } from 'react-router-dom'

import {
  exportFormatedMoney,
  useQueryParams,
} from '../../../../util/utils'
import { usePermissions } from '../../../../hooks/usePermission'
import colors from '../../../../assets/colors'

import { useLocation } from 'react-router-dom'
import Icon from '@mdi/react'
import { mdiCash100 } from '@mdi/js'
import filterStylesComponents from '../../../../assets/filterComponentsStyles'
import InputNumberCustom from '../../../../components/hooks/BaseInputNumber'
import {
  fetchLaundryClient,
  updateCashbackPointValue,
} from '../PointValueActions'

const useStyles = makeStyles({
  wrapper: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 4,
  },
  box: {
    minWidth: '540px',
    border: '2px solid',
    borderColor: colors.primary,
    borderRadius: '1.4em',
    width: '30%',
    height: '60%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 4,
    padding: '.8em',
  },
  rowMessage: {
    padding: '4px 0',
    color: colors.textPrimary,
    fontSize: '14px',
  },
  message: {
    display: 'flex',
    alignItems: 'center',
    height: 'auto',
    fontWeight: 'normal',
    color: colors.textPrimary,
  },
})

const PointValue = props => {
  const laundryClient = useSelector(state => state.pointValue.laundryClient)
  const permissionUser = useSelector(state => state.auth.permissionUser)
  const { canUpdate } = usePermissions()

  const location = useLocation()
  const dispatch = useDispatch()

  const classes = useStyles()
  const filterStyles = filterStylesComponents()

  const filters = useQueryParams(location?.search)

  const [pointValue, setPointValue] = useState(0)

  const handleChangeFinalValue = e => {
    const { value } = e
    setPointValue(value)
  }

  const handleSubmit = e => {
    e.preventDefault()
    dispatch(updateCashbackPointValue(pointValue, laundryClient?.id))
  }

  useEffect(() => {
    if (laundryClient?.cashback_point_value) setPointValue(laundryClient?.cashback_point_value)
  }, [laundryClient])

  useEffect(() => {
    dispatch(fetchLaundryClient())
  }, [location])

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12}>
        <Typography
          variant="h4"
          style={{ fontSize: '20px', color: colors.primary }}
        >
          Valor de Conversão do Ponto
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography className={classes.message}>
          Defina quantos Reais (R$) o cliente recebe a cada 1 ponto acumulado no
          programa de cashback.
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Grid
          container
          justifyContent="flex-start"
          spacing={4}
          alignItems="flex-start"
        >
          <Grid item>
            <form onSubmit={handleSubmit}>
              <Box
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '16px',
                  width: '550px',
                  padding: '1.4em',
                  border: '1px solid',
                  borderColor: colors.graylight,
                  borderRadius: '1.4em',
                }}
              >
                <TextField
                  label="Fator de conversão (R$/Ponto)"
                  placeholder="0,00"
                  helperText="Se você definir R$ 0,05, um cliente com 100 pontos terá R$ 5,00 de cashback."
                  fullWidth
                  value={pointValue}
                  onChange={handleChangeFinalValue}
                  InputProps={{
                    inputComponent: InputNumberCustom,
                    inputProps: {
                      prefix: 'R$ ',
                      allowNegative: false,
                      style: {
                        color: colors.textPrimary,
                      },
                    },
                  }}
                />

                <Box
                  style={{
                    display: 'flex',
                    width: '100%',
                    justifyContent: 'flex-end',
                  }}
                >
                  {canUpdate('cashback-valor-ponto', permissionUser) && (
                    <Button
                      type="submit"
                      className={filterStyles.btnSalvar}
                      // onClick={confirmChangeModel}
                    >
                      Salvar
                    </Button>
                  )}
                </Box>
              </Box>
            </form>
          </Grid>

          <Grid item>
            <Box
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4px',
                minWidth: '320px',
                padding: '1.4em',
                border: '1px solid',
                borderColor: colors.graylight,
                borderRadius: '1.4em',
              }}
            >
              <Typography
                variant="h4"
                style={{ fontSize: '16px', color: colors.primary }}
              >
                Simulação
              </Typography>

              <Box style={{ width: '100%', display: 'flex', gap: '12px' }}>
                <Typography
                  style={{ fontSize: '14px', color: colors.secondary }}
                >
                  1 Ponto =
                </Typography>
                <Typography
                  style={{ fontSize: '14px', color: colors.textGray }}
                >
                  {exportFormatedMoney(pointValue)}
                </Typography>
              </Box>
              <Box style={{ width: '100%', display: 'flex', gap: '12px' }}>
                <Typography
                  style={{ fontSize: '14px', color: colors.secondary }}
                >
                  1.000 Pontos =
                </Typography>
                <Typography
                  style={{ fontSize: '14px', color: colors.textGray }}
                >
                  {exportFormatedMoney(1000 * pointValue)}
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default PointValue
